import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";
import { getMerchantTransactions } from "utils/AxiosUtil";
import { Payment } from "types/payment";

export interface MerchantTransactionsResult {
  transactions: Payment[];
  more: boolean;
}

// Merchant transactions + the `more` (load-more) flag, keyed by the merchant's
// on-chain address (resolved from useMerchantInfo). Disabled until it's available.
export function useMerchantTransactions(merchantAddress: string | undefined) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery<MerchantTransactionsResult>({
    // History is per-token on the backend, so this is correctness, not just freshness.
    queryKey: ["merchantTransactions", merchantAddress, token],
    queryFn: async () => {
      const res = await getMerchantTransactions(
        merchantAddress!,
        networkType,
        token,
      );
      return res.data;
    },
    enabled: !!user && !!merchantAddress,
  });
}
